var n=function(n){return n.reduce((function(n,r){return Object.keys(r).forEach((function(c){n[c]||(n[c]=""),n[c]="\n        ".concat(n[c],"\n        ").concat(r[c],"\n      ")})),n}),{})},r=function(r){return Array.isArray(r)?n(r):r};export{r as u,n as z};
//# sourceMappingURL=useTheme-76ff76fc.js.map
